/** Indicadores de contactos fiscales para tablero de asignación (PF vs PM). */

export function fiscalContactSummaryLabel(readiness) {
  if (!readiness) return "—";
  return readiness.summary_label || "—";
}

export function fiscalContactSummaryTone(readiness) {
  if (!readiness) return "gray";
  const tipo = readiness.tipo_persona;
  if (tipo === "fisica") {
    return readiness.empresa_whatsapp_ok ? "green" : "amber";
  }
  const hasEmpresa = readiness.empresa_whatsapp_ok;
  const hasPersonal = readiness.personal_contacts_ok;
  if (hasEmpresa && hasPersonal) return "green";
  if (hasEmpresa || hasPersonal) return "amber";
  return "rose";
}

export function tipoPersonaFiscalLabel(tipo) {
  const t = String(tipo || "").toLowerCase();
  if (t === "fisica") return "Persona física";
  if (t === "moral") return "Persona moral";
  return "—";
}
